import * as angular from "angular";
import {IController} from "angular";
import {OmsService} from "../../services/oms-service.service";

export class OmsOrderTimelineLogsCtrl implements IController{
  orderId: any;

  private timeline;
  public isScrollable: boolean;

  constructor(private omsService: OmsService, private $mdMedia) {
  }

  $onInit() {
    this._getLogsTimeline();
  }

  $onChanges(changes) {
    if (changes.orderId && !changes.orderId.isFirstChange()) {
      this._getLogsTimeline();
    }
  }

  $doCheck() {
    // this.isScrollable = !this.$mdMedia('xl')
    this.isScrollable = true;
  };

  private _getLogsTimeline() {
    if (this.orderId) {
      this.omsService.getLogsTimeline(this.orderId)
        .then((timeline) => {
          this.timeline = timeline;
        })
    } else {
      this.timeline = undefined;
    }
  }


}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderTimelineLogs', {
    bindings: {
      orderId: '<'
    },
    template: require('./oms-order-timeline-logs.html').default,
    controller: OmsOrderTimelineLogsCtrl
  });
